<h2 mat-dialog-title>Reset Pano</h2>
<mat-dialog-content>
  Are you sure you want to undo all your selections?
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close>No</button>
  <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</mat-dialog-actions>